import isNotNil from "../../ldsh/isNotNil"
import type { HasAnnexPoints } from "../HasAnnexPoints.type"
import type { AnnexableEntityUnion } from "./AnnexableEntityUnion.type"
import type { Entity } from "./index"

export default function isEntityAnnexable (entity: Entity): entity is AnnexableEntityUnion {
  return isNotNil((entity as HasAnnexPoints).ap)
}